import { __assign } from "tslib";
import { Checkbox } from './checkbox';
import { renderAndMountComponent } from '@wix/answers-lib';
import { getLegacyBaseDriverFromWrapper } from '../../common/base-driver';
import * as React from 'react';
export var createLegacyCheckboxDriver = function (wrapper) {
    var baseDriver = getLegacyBaseDriverFromWrapper(wrapper, '.checkbox', Checkbox.name);
    return {
        click: function () { return baseDriver.find('input').click(); },
        getLabel: function () { return baseDriver.find('.checkbox-body').getText(); },
        isChecked: function () { return baseDriver.elem.classList.contains('checked'); },
        isLarge: function () { return baseDriver.elem.classList.contains('large'); },
        isDisabled: function () { return baseDriver.elem.classList.contains('disabled'); }
    };
};
export var createCheckbox = function (props) {
    var element = renderAndMountComponent(React.createElement(Checkbox, __assign({}, props)));
    return createLegacyCheckboxDriver(element);
};
//# sourceMappingURL=checkbox.driver.js.map